import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";
import ConversionGroup from "../../../../groups/ConversionGroup";

class MetricBookingcountKayak extends MetricBase {
    constructor() {
        super({
            field: "metric_bookingcount",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.kayak.bookingcount.chartName"),
            serieLabel: i18n.t("metrics.kayak.bookingcount.serieLabel"),
            tooltip: i18n.t("metrics.kayak.bookingcount.tooltip"),
            group: new ConversionGroup(),
        });
    }
}

export default MetricBookingcountKayak;
